import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-md navbar-dark bg-primary mb-0" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "navbar-brand company-name" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-toggle": "collapse",
  "data-target": "#navbarNavAltMarkup"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_5 = {
  class: "collapse navbar-collapse",
  id: "navbarNavAltMarkup"
}
const _hoisted_6 = {
  id: "aboutId",
  class: "navbar-nav fw-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.companyIconFileName,
        class: "d-inline-block align-text-bottom",
        "border-color": "red",
        width: "65",
        height: "65"
      }, null, 8, _hoisted_2),
      _createElementVNode("a", _hoisted_3, _toDisplayString(_ctx.companyName), 1),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_router_link, {
            to: "/",
            "data-toggle": "collapse",
            "data-target": ".navbar-collapse.show"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Home")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/login",
            "data-toggle": "collapse",
            "data-target": ".navbar-collapse.show"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Login")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/schedule",
            name: "schedule",
            "data-toggle": "collapse",
            "data-target": ".navbar-collapse.show"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Schedule")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/jobcalls",
            name: "jobcalls",
            "data-toggle": "collapse",
            "data-target": ".navbar-collapse.show"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Jobcalls")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/profile",
            name: "profile",
            "data-toggle": "collapse",
            "data-target": ".navbar-collapse.show"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Profile")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/documents",
            name: "documents",
            "data-toggle": "collapse",
            "data-target": ".navbar-collapse.show"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Documents")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/changepassword",
            name: "changepassword",
            "data-toggle": "collapse",
            "data-target": ".navbar-collapse.show"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Change Password ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/logout",
            name: "logout",
            "data-toggle": "collapse",
            "data-target": ".navbar-collapse.show"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Logout")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/register",
            name: "register",
            "data-toggle": "collapse",
            "data-target": ".navbar-collapse.show"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Register ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}